import React from 'react';
import moment from 'moment';
import { get } from 'lodash/fp';
import PropTypes from 'prop-types';
import { Permissions } from '@upstart/harmony/lib/constants';
import { SplitButton } from 'react-bootstrap/lib';
import DeleteButton from './DeleteButton';
import ImportButton from './ImportButton';
import ValidateButton from './ValidateButton';
import RunAutomationButton from './RunAutomationButton';
import CancelButton from './CancelButton';
import withDealerPermission from './dealerPermission';

const canRunTests = (dealer) =>
  get('dealerVerification.status')(dealer) !== 'in-progress';

const canCancel = (dealer) => {
  // Cancel action is only valid if validation is in progress
  if (
    !dealer ||
    !dealer.dealerVerification ||
    dealer.dealerVerification.status !== 'in-progress'
  ) {
    return false;
  }
  const updated = moment(dealer.dealerVerification.updatedAt).utc().valueOf();
  const now = moment().utc().valueOf();
  const millisecondsSinceUpdated = now - updated;
  // Enable Cancel action only if validation started more than 10 mins ago
  return millisecondsSinceUpdated >= 600000; // 10 mins
};

const canImport = (dealer) => dealer && dealer.Feeds && dealer.Feeds.length > 0;

function EditButton({
  dealer,
  editDealer,
  onDelete,
  onValidate,
  runAutomation,
  onCancel,
  onInventoryImport,
}) {
  return (
    <SplitButton
      title="Edit"
      key={dealer.id}
      id={`split-button-basic-${dealer.id}`}
      onClick={() => {
        editDealer(dealer.id);
      }}
    >
      {canRunTests(dealer) && (
        <ValidateButton dealer={dealer} onValidate={onValidate} />
      )}
      {canRunTests(dealer) && (
        <>
          <RunAutomationButton dealer={dealer} runAutomation={runAutomation} />
          <RunAutomationButton
            dealer={dealer}
            runAutomation={runAutomation}
            type="online"
          />
        </>
      )}
      {canCancel(dealer) && (
        <CancelButton dealer={dealer} onCancel={onCancel} />
      )}
      {canImport(dealer) && (
        <ImportButton dealer={dealer} onInventoryImport={onInventoryImport} />
      )}
      <DeleteButton dealer={dealer} onDelete={onDelete} />
    </SplitButton>
  );
}

EditButton.propTypes = {
  dealer: PropTypes.object,
  editDealer: PropTypes.func,
  onDelete: PropTypes.func,
  onValidate: PropTypes.func,
  runAutomation: PropTypes.func,
  onCancel: PropTypes.func,
  onInventoryImport: PropTypes.func,
};

export default withDealerPermission(Permissions.UPDATE)(EditButton);
